/**
 * 订单管理 交易订单
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>漫画课程用户认证</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="keyword" placeholder="输入用户手机号/昵称"></el-input>
        <!-- <el-input size="small" v-model="formInline.machineNo" placeholder="输入邀请人用户手机号"></el-input> -->
      </el-form-item>

      <!-- <el-form-item>
        <el-select size="small" v-model="formInline.statusType" placeholder="请选择">
          <el-option v-for="type in statusType" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item> -->

            <el-select v-model="isVip" placeholder="请选择" @change="handleUserTypeChange" >

                <el-option label="普通用户" value="4"></el-option>
                <el-option label="待认证用户" value="3"></el-option>
                <el-option label="vip2用户" value="1"></el-option>
                <el-option label="校长用户不限制公里" value="2"></el-option>
            </el-select>

      <el-form-item label="有效期：">
        <el-select v-model="validityFilter" size="small" placeholder="全部" :disabled="isVip!='1' && isVip!='2'" @change="handleValidityFilterChange">
          <el-option label="全部" value=""></el-option>
          <el-option label="有效" value="active"></el-option>
          <el-option label="失效" value="expired"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
    <div class="expiry-toolbar">
      <template v-if="isVip=='2'">
        <span class="expiry-toolbar-title"><i class="el-icon-bell"></i> 到期提醒</span>
        <el-button size="small" :type="expiryFilter === 'thisMonth' ? 'warning' : 'default'" icon="el-icon-date" @click="showThisMonthExpiry">
          本月到期 <strong>{{ expirySummary.thisMonthCount }}</strong> 个
        </el-button>
        <el-button v-if="expiryFilter" size="small" type="text" icon="el-icon-close" @click="clearExpiryFilter">显示全部</el-button>
      </template>
      <el-button class="batch-expire-button" size="small" type="primary" icon="el-icon-edit-outline" @click="openBatchExpireDialog">
        批量设置到期时间<span v-if="selectedUserRows.length">（{{ selectedUserRows.length }}）</span>
      </el-button>
    </div>
    <div v-show="tableHasHorizontalOverflow" ref="tableTopScrollbar" class="table-scrollbar-top" @scroll="handleTopTableScroll">
      <div class="table-scrollbar-top-content" :style="{ width: tableScrollWidth + 'px' }"></div>
    </div>
    <!--列表-->
    <el-table ref="userTable" class="user-table" size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">

      <el-table-column label="选择" width="72" align="center">
        <template slot="header">
          <div class="user-selection-header"><el-checkbox :value="allUserRowsSelected" :indeterminate="userSelectionIndeterminate" :disabled="!listData.length" @change="toggleAllUserRows"></el-checkbox><span>选择</span></div>
        </template>
        <template slot-scope="scope"><el-checkbox :value="isUserRowSelected(scope.row)" @change="toggleUserRow(scope.row, $event)"></el-checkbox></template>
      </el-table-column>

      <el-table-column sortable prop="id" label="id" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="avatar" label="头像" width="80"> 
        <template slot-scope="scope">
          <img class="tech-avatar" style="width: 40px; height: 40px;" :src="scope.row.avatar">
        </template>
      </el-table-column>
      <el-table-column sortable prop="nickName" label="用户昵称" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="mobile" label="手机号" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="campusName2" label="校区名称" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="address2" label="具体地址" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="realName" label="法人代表" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="identityCard" label="身份证号码" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="inviterId" label="主账号ID" width="110" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="principalName" label="所属主账号" width="180" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{ scope.row.principalName || '-' }}</div>
        </template>
      </el-table-column>
      <el-table-column sortable prop="remark" label="备注" width="120" show-overflow-tooltip>
      </el-table-column>

      <el-table-column prop="phoneType" label="手机类型" width="100" show-overflow-tooltip></el-table-column>
      <el-table-column label="认证身份" width="120">
        <template slot-scope="scope">
          <span>{{ Number(scope.row.isVip2) === 2 ? '校长用户' : (Number(scope.row.isVip2) === 1 ? 'VIP用户' : '未开通') }}</span>
        </template>
      </el-table-column>

      <el-table-column label="VIP开通时间" width="200">
        <template slot-scope="scope">
          <div class="period-cell">
            <span>{{ getVip2OpeningTime(scope.row) || '-' }}</span>
            <el-tag v-if="isVip2SubAccount(scope.row)" size="mini" type="info">跟随主账号</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="VIP到期时间" width="200">
        <template slot-scope="scope">
          <div class="period-cell">
            <span>{{ getVip2ExpireTime(scope.row) || '-' }}</span>
            <el-tag v-if="isVip2SubAccount(scope.row)" size="mini" type="info">跟随主账号</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="有效期状态" width="120" align="center">
        <template slot-scope="scope">
          <el-tag size="mini" :type="getVipStatusType(scope.row.isVip2, getVip2ExpireTime(scope.row))">
            {{ getVipStatusText(scope.row.isVip2, getVip2ExpireTime(scope.row)) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column sortable prop="createTime" label="创建时间" width="150">
        <template slot-scope="scope">
          <div>{{transformDate(scope.row.createTime)}}</div>
        </template>
      </el-table-column>
      <el-table-column fixed="right" align="center" label="操作" width="310">
        <template slot-scope="scope">
          <div class="action-buttons">
            <el-button size="mini" type="primary" v-if="isVip=='3'" @click="setMemberStatus(2, scope.row.id,scope.row.remark,scope.row.openingTime2,scope.row.vip2ExpireTime,scope.row.inviterId)">设为校长</el-button>
            <el-button size="mini" type="primary" v-if="scope.row.isVip2==0" @click="setMemberStatus(1, scope.row.id,scope.row.remark,scope.row.openingTime2,scope.row.vip2ExpireTime,scope.row.inviterId)">设为VIP2</el-button>
            <el-button size="mini" type="warning" v-if="scope.row.isVip2==1||scope.row.isVip2==2" @click="setMemberStatus(0, scope.row.id,scope.row.remark,scope.row.openingTime2,scope.row.vip2ExpireTime,scope.row.inviterId)">取消VIP2</el-button>
            <el-button size="mini" type="success" @click="open(scope.row.isVip2, scope.row.id,scope.row.remark,scope.row.openingTime2,scope.row.vip2ExpireTime,scope.row.inviterId)">备注</el-button>
            <el-button size="mini" type="success" v-if="!isVip2SubAccount(scope.row)" @click="openOpeningDialog(scope.row)">设置开通时间</el-button>
            <el-button size="mini" type="success" plain v-if="!isVip2SubAccount(scope.row)" @click="openExpireDialog(scope.row)">设置到期时间</el-button>
            <el-button size="mini" type="primary" plain v-if="scope.row.isVip2==1" @click="openBindDialog(scope.row)">绑定主账号</el-button>
            <el-button size="mini" type="danger"  @click="setIsDelete(scope.row.id)">删除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <el-dialog title="设置VIP2开通时间" :visible.sync="openingFormVisible" width="420px" @close="closeOpeningDialog">
      <el-form label-width="110px">
        <el-form-item label="VIP2开通时间">
          <el-date-picker
            v-model="openingForm.openingTime2"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
            placeholder="请选择VIP2开通时间"
            clearable
            style="width: 100%;">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeOpeningDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="saveOpeningTime">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog title="设置VIP2到期时间" :visible.sync="expireFormVisible" width="420px" @close="closeExpireDialog">
      <el-form label-width="110px">
        <el-form-item label="VIP2到期时间">
          <el-date-picker
            v-model="expireForm.vip2ExpireTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
            placeholder="请选择VIP2到期时间"
            clearable
            style="width: 100%;">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeExpireDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="saveExpireTime">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog title="批量设置VIP2到期时间" :visible.sync="batchExpireVisible" width="700px" custom-class="batch-expire-dialog" @close="closeBatchExpireDialog">
      <el-form label-width="110px">
        <el-form-item label="已选用户">
          <el-button type="text" class="selected-users-toggle" :icon="selectedUsersExpanded ? 'el-icon-arrow-up' : 'el-icon-view'" @click="selectedUsersExpanded = !selectedUsersExpanded">
            共 {{ selectedUserRows.length }} 个账号，{{ selectedUsersExpanded ? '收起信息' : '查看基础信息' }}
          </el-button>
        </el-form-item>
        <el-collapse-transition>
          <div v-show="selectedUsersExpanded" class="selected-users-table">
            <el-table :data="selectedUserRows" size="mini" border max-height="260">
              <el-table-column prop="id" label="ID" width="80"></el-table-column>
              <el-table-column prop="realName" label="姓名" width="110" show-overflow-tooltip></el-table-column>
              <el-table-column prop="mobile" label="手机号" width="140" show-overflow-tooltip></el-table-column>
              <el-table-column prop="campusName2" label="校区名称" min-width="180" show-overflow-tooltip></el-table-column>
            </el-table>
          </div>
        </el-collapse-transition>
        <el-form-item label="统一到期时间" required>
          <el-date-picker v-model="batchExpireForm.vip2ExpireTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" placeholder="请选择统一到期时间" :clearable="false" style="width: 100%;"></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeBatchExpireDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="batchExpireLoading" @click="saveBatchExpireTime">确认批量设置</el-button>
      </div>
    </el-dialog>
    <el-dialog title="绑定主账号" :visible.sync="bindDialogVisible" width="420px" @close="closeBindDialog">
      <el-form label-width="90px">
        <el-form-item label="选择主账号">
          <el-select
            v-model="bindForm.inviterId"
            filterable
            remote
            clearable
            reserve-keyword
            placeholder="请输入主账号校区名/手机号搜索"
            :remote-method="loadPrincipalOptions"
            :loading="principalLoading"
            style="width: 100%;">
            <el-option
              v-for="item in principalOptions"
              :key="String(item.id)"
              :label="formatPrincipalOption(item)"
              :value="String(item.id)">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeBindDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="savePrincipalBinding">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="title" :visible.sync="editFormVisible" width="80%" @click='closeDialog("edit")'>
      <el-form label-width="120px"  ref="editForm" >
     
        <el-form-item label="标题" prop="title">
          <el-input size="small" v-model="from.title" auto-complete="off" placeholder="请输入标题"></el-input>
        </el-form-item>
             



      </el-form>

      <el-form label-width="120px"  ref="editForm" >
     
        <el-form-item label="简短内容" prop="briefContent">
          <el-input size="small" v-model="from.briefContent" auto-complete="off" placeholder="简短内容"></el-input>
        </el-form-item>
             



      </el-form>


      <el-form label-width="120px"  ref="editForm" >
     
        <el-form-item label="分类名称" prop="roleName">
            <quill-editor
            v-model="from.content"
            :options="editorOption"
            style="height: 200px;"
            ref="QuillEditor">
            </quill-editor>
        </el-form-item>



      </el-form>






      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="addNotice(0)">发送</el-button>
        <!-- <el-button size="small" type="primary" :loading="loading" class="title" @click="addNotice(1)">给所有人发送</el-button> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUserList2,setUserInfo2,setIsDelete,getPrincipalOptions,batchSetVip2ExpireTime} from '../../api/userMG'
import Pagination from '../../components/Pagination'





import client from "@/utils/ossClient.js";
import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

// 工具栏配置
const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // toggled buttons
  ["blockquote", "code-block"],

  [{ header: 1 }, { header: 2 }], // custom button values
  [{ list: "ordered" }, { list: "bullet" }],
  [{ script: "sub" }, { script: "super" }], // superscript/subscript
  [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
  [{ direction: "rtl" }], // text direction

  [{ size: ["small", false, "large", "huge"] }], // custom dropdown
  [{ header: [1, 2, 3, 4, 5, 6, false] }],

  [{ color: [] }, { background: [] }], // dropdown with defaults from theme
  [{ font: [] }],
  [{ align: [] }],
  ["link", "image", "video"], // 对于图片上传这是重点
  ["clean"], // remove formatting button
];


export default {
  data() {
    return {
      uploadVisible:false,
      cursorIndex: 0,
      isVip:"3",
      editorOption: {
        modules: {
          toolbar: {
            container: toolbarOptions, // 工具栏
            handlers: {
              image: (value) => {
                if (value) {
                  // 在这里编写图片按钮点击操作
                  this.uploadVisible = true;
                  this.cursorIndex =
                    this.$refs.QuillEditor.quill.getSelection().index;
                } else {
                  this.quill.format("image", false);
                }
              },
            },
          },
        },
      },


      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      openingFormVisible: false,
      expireFormVisible: false,
      batchExpireVisible: false,
      selectedUsersExpanded: false,
      bindDialogVisible: false,
      principalLoading: false,
      batchExpireLoading: false,
      title: '预览',
      statusType: [
        { key: '请选择', value: 0 },
        { key: '正常', value: 1 },
        { key: '冻结', value: 2 }
      ],

      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        pageSizes: [10, 20, 50, 100, 200],
        total: 10
        
      },

      keyword:"",
      validityFilter: "",
      expiryFilter: "",
      expirySummary: { thisMonthCount: 0 },
      principalOptions: [],
      selectedUserRows: [],
      tableScrollWidth: 0,
      tableViewportWidth: 0,
      tableBodyWrapper: null,
      tableResizeTimer: null,


      from:{
        title:"",
        briefContent:"",
        content:"",
        userId:"",
        sendType:0,

      },
      openingForm: {
        id: "",
        isVip2: 0,
        remark: "",
        openingTime2: "",
        vip2ExpireTime: "",
        inviterId: ""
      },
      expireForm: {
        id: "",
        isVip2: 0,
        remark: "",
        openingTime2: "",
        vip2ExpireTime: "",
        inviterId: ""
      },
      bindForm: {
        id: "",
        isVip2: 0,
        remark: "",
        openingTime2: "",
        vip2ExpireTime: "",
        inviterId: ""
      },
      batchExpireForm: { vip2ExpireTime: "" }


    }
  },
  // 注册组件
  components: {
    Pagination
  },
  computed: {
    currentPageSelectedUserCount() {
      const ids = new Set(this.selectedUserRows.map(item => String(item.id)))
      return this.listData.filter(item => ids.has(String(item.id))).length
    },
    allUserRowsSelected() {
      return this.listData.length > 0 && this.currentPageSelectedUserCount === this.listData.length
    },
    userSelectionIndeterminate() {
      return this.currentPageSelectedUserCount > 0 && this.currentPageSelectedUserCount < this.listData.length
    },
    tableHasHorizontalOverflow() {
      return this.tableScrollWidth > this.tableViewportWidth + 1
    }
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.loadComicRoute()
  },
  watch: {
    '$route.query'() {
      this.loadComicRoute()
    }
  },
  mounted() {
    window.addEventListener('resize', this.scheduleTableScrollbarRefresh)
    this.$nextTick(this.bindTableScrollbar)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.scheduleTableScrollbarRefresh)
    if (this.tableBodyWrapper) this.tableBodyWrapper.removeEventListener('scroll', this.handleTableBodyScroll)
    if (this.tableResizeTimer) clearTimeout(this.tableResizeTimer)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    loadComicRoute() {
      const query = this.$route.query || {}
      this.keyword = typeof query.mobile === 'string' ? query.mobile : ''
      this.isVip = ['1', '2'].indexOf(String(query.isVip2)) >= 0 ? String(query.isVip2) : '3'
      this.validityFilter = ''
      this.expiryFilter = ''
      this.selectedUserRows = []
      this.getdata(1)
    },
    isUserRowSelected(row) {
      return this.selectedUserRows.some(item => String(item.id) === String(row && row.id))
    },
    toggleUserRow(row, checked) {
      const rowId = String(row && row.id)
      const selected = this.selectedUserRows.filter(item => String(item.id) !== rowId)
      if (checked) selected.push(row)
      this.selectedUserRows = selected
    },
    toggleAllUserRows(checked) {
      const currentIds = new Set(this.listData.map(item => String(item.id)))
      const otherPages = this.selectedUserRows.filter(item => !currentIds.has(String(item.id)))
      this.selectedUserRows = checked ? otherPages.concat(this.listData) : otherPages
    },
    bindTableScrollbar() {
      const table = this.$refs.userTable
      const bodyWrapper = table && table.bodyWrapper
      if (!bodyWrapper) return
      if (this.tableBodyWrapper && this.tableBodyWrapper !== bodyWrapper) this.tableBodyWrapper.removeEventListener('scroll', this.handleTableBodyScroll)
      if (this.tableBodyWrapper !== bodyWrapper) {
        this.tableBodyWrapper = bodyWrapper
        this.tableBodyWrapper.addEventListener('scroll', this.handleTableBodyScroll)
      }
      this.refreshTableScrollbar()
    },
    refreshTableScrollbar() {
      this.$nextTick(() => {
        const table = this.$refs.userTable
        if (table && table.doLayout) table.doLayout()
        this.$nextTick(() => {
          const body = table && table.bodyWrapper
          if (!body) return
          this.tableScrollWidth = body.scrollWidth
          this.tableViewportWidth = body.clientWidth
          if (this.$refs.tableTopScrollbar) this.$refs.tableTopScrollbar.scrollLeft = body.scrollLeft
        })
      })
    },
    scheduleTableScrollbarRefresh() {
      if (this.tableResizeTimer) clearTimeout(this.tableResizeTimer)
      this.tableResizeTimer = setTimeout(() => { this.tableResizeTimer = null; this.bindTableScrollbar() }, 80)
    },
    handleTopTableScroll(event) {
      if (this.tableBodyWrapper) this.tableBodyWrapper.scrollLeft = event.target.scrollLeft
    },
    handleTableBodyScroll(event) {
      const top = this.$refs.tableTopScrollbar
      if (top && Math.abs(top.scrollLeft - event.target.scrollLeft) > 1) top.scrollLeft = event.target.scrollLeft
    },
    handleUserTypeChange() {
      this.validityFilter = ""
      this.expiryFilter = ""
      this.selectedUserRows = []
      this.getdata(1)
    },
    handleValidityFilterChange() {
      this.expiryFilter = ""
      this.getdata(1)
    },
    showThisMonthExpiry() {
      this.validityFilter = ""
      this.expiryFilter = "thisMonth"
      this.getdata(1)
    },
    clearExpiryFilter() {
      this.expiryFilter = ""
      this.getdata(1)
    },
    openBatchExpireDialog() {
      if (!this.selectedUserRows.length) {
        this.$message({ type: 'warning', message: '请先勾选需要设置到期时间的账号' })
        return
      }
      this.batchExpireForm.vip2ExpireTime = ""
      this.selectedUsersExpanded = false
      this.batchExpireVisible = true
    },
    closeBatchExpireDialog() {
      this.batchExpireVisible = false
      this.selectedUsersExpanded = false
      this.batchExpireForm.vip2ExpireTime = ""
    },
    saveBatchExpireTime() {
      if (!this.batchExpireForm.vip2ExpireTime) {
        this.$message({ type: 'warning', message: '请选择统一到期时间' })
        return
      }
      const userIds = this.selectedUserRows.map(item => Number(item.id)).filter(id => id > 0)
      if (!userIds.length) return
      this.batchExpireLoading = true
      batchSetVip2ExpireTime({ userIds, vip2ExpireTime: this.batchExpireForm.vip2ExpireTime }).then((res) => {
        this.batchExpireLoading = false
        if (res.code == 200) {
          this.$message({ type: 'success', message: `已统一设置 ${(res.data && res.data.updatedCount) || userIds.length} 个账号的到期时间` })
          this.selectedUserRows = []
          this.closeBatchExpireDialog()
          this.getdata(this.pageparm.currentPage || 1)
        } else this.$message({ type: 'info', message: res.msg })
      }).catch(() => { this.batchExpireLoading = false; this.$message({ type: 'error', message: '批量设置失败，请稍后重试' }) })
    },
    isVip2SubAccount(row) {
      return Boolean(row && Number(row.isVip2) === 1 && row.inviterId && Number(row.inviterId) > 0)
    },
    getVip2OpeningTime(row) {
      if (!row) {
        return ""
      }
      return this.isVip2SubAccount(row) ? (row.principalOpeningTime2 || "") : (row.openingTime2 || "")
    },
    getVip2ExpireTime(row) {
      if (!row) {
        return ""
      }
      return this.isVip2SubAccount(row) ? (row.principalVip2ExpireTime || "") : (row.vip2ExpireTime || "")
    },
    openOpeningDialog(row) {
      this.openingForm = {
        id: row.id,
        isVip2: row.isVip2,
        remark: row.remark || "",
        openingTime2: row.openingTime2 || "",
        vip2ExpireTime: row.vip2ExpireTime || "",
        inviterId: row.inviterId ? String(row.inviterId) : ""
      }
      this.openingFormVisible = true
    },
    closeOpeningDialog() {
      this.openingFormVisible = false
      this.openingForm = {
        id: "",
        isVip2: 0,
        remark: "",
        openingTime2: "",
        vip2ExpireTime: "",
        inviterId: ""
      }
    },
    saveOpeningTime() {
      this.setMemberStatus(
        this.openingForm.isVip2,
        this.openingForm.id,
        this.openingForm.remark,
        this.openingForm.openingTime2,
        this.openingForm.vip2ExpireTime,
        this.openingForm.inviterId
      )
    },
    openExpireDialog(row) {
      this.expireForm = {
        id: row.id,
        isVip2: row.isVip2,
        remark: row.remark || "",
        openingTime2: row.openingTime2 || "",
        vip2ExpireTime: row.vip2ExpireTime || "",
        inviterId: row.inviterId ? String(row.inviterId) : ""
      }
      this.expireFormVisible = true
    },
    closeExpireDialog() {
      this.expireFormVisible = false
      this.expireForm = {
        id: "",
        isVip2: 0,
        remark: "",
        openingTime2: "",
        vip2ExpireTime: "",
        inviterId: ""
      }
    },
    saveExpireTime() {
      this.setMemberStatus(
        this.expireForm.isVip2,
        this.expireForm.id,
        this.expireForm.remark,
        this.expireForm.openingTime2,
        this.expireForm.vip2ExpireTime,
        this.expireForm.inviterId
      )
    },
    openBindDialog(row) {
      this.bindForm = {
        id: row.id,
        isVip2: row.isVip2,
        remark: row.remark || "",
        openingTime2: row.openingTime2 || "",
        vip2ExpireTime: row.vip2ExpireTime || "",
        inviterId: row.inviterId ? String(row.inviterId) : ""
      }
      this.bindDialogVisible = true
      this.loadPrincipalOptions("")
    },
    closeBindDialog() {
      this.bindDialogVisible = false
      this.bindForm = {
        id: "",
        isVip2: 0,
        remark: "",
        openingTime2: "",
        vip2ExpireTime: "",
        inviterId: ""
      }
    },
    savePrincipalBinding() {
      this.setMemberStatus(
        this.bindForm.isVip2,
        this.bindForm.id,
        this.bindForm.remark,
        this.bindForm.openingTime2,
        this.bindForm.vip2ExpireTime,
        this.bindForm.inviterId
      )
    },
    loadPrincipalOptions(keyword) {
      this.principalLoading = true
      getPrincipalOptions({
        keyword: keyword || "",
        scene: 2
      }).then((res) => {
        this.principalLoading = false
        if (res.code == 200) {
          this.principalOptions = res.data.list || []
          return
        }
        this.$message({
          type: "info",
          message: res.msg,
        })
      }).catch(() => {
        this.principalLoading = false
      })
    },
    formatPrincipalOption(item) {
      return `${item.campusName2 || item.realName || '未命名主账号'} / ${item.mobile || item.id}`
    },
    open(status,id,remark,openingTime,vip2ExpireTime,inviterId) {
      var self = this;
        this.$prompt('请输入备注', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(({ value }) => {
          self.setMemberStatus(status,id,value,openingTime,vip2ExpireTime,inviterId)
          

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });       
        });
    },

    
    setIsDelete(id) {
      this.loading = true;

      var parameter = {
        id: id
      };
      setIsDelete(parameter).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.getdata(1)
          return;
        }
        this.$message({
          type: "info",
          message: res.msg,
        });
      });
    },
    setMemberStatus(status,id,remark,openingTime,vip2ExpireTime,inviterId) {
      this.loading = true;
      if (!openingTime) {
        openingTime = ""
      }
      if (!vip2ExpireTime) {
        vip2ExpireTime = ""
      }
      if (!inviterId) {
        inviterId = ""
      }
      var parameter = {
        isVip2: status,
        remark:remark,
        openingTime2:openingTime,
        vip2ExpireTime: vip2ExpireTime,
        inviterId: inviterId,
        id: id,
      };
      setUserInfo2(parameter).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.closeOpeningDialog()
          this.closeExpireDialog()
          this.closeBindDialog()
          this.getdata(1)
          return;
        }
        this.$message({
          type: "info",
          message: res.msg,
        });
      });
    },
    getVipStatusText(status, expireTime) {
      if (!status || Number(status) === 0) {
        return '未开通'
      }
      if (!expireTime) {
        return '未设置'
      }
      return this.isExpired(expireTime) ? '已过期' : '有效中'
    },
    getVipStatusType(status, expireTime) {
      if (!status || Number(status) === 0) {
        return 'info'
      }
      if (!expireTime) {
        return 'warning'
      }
      return this.isExpired(expireTime) ? 'danger' : 'success'
    },
    isExpired(expireTime) {
      const parsedTime = this.parseDateTime(expireTime)
      if (!parsedTime) {
        return false
      }
      return parsedTime.getTime() <= Date.now()
    },
    parseDateTime(value) {
      if (!value) {
        return null
      }
      const text = String(value).trim()
      if (!text) {
        return null
      }
      if (/^\d{4}[-/.]\d{1,2}[-/.]\d{1,2}$/.test(text)) {
        return new Date(text.replace(/[/.]/g, '-') + ' 23:59:59')
      }
      return new Date(text.replace(/\./g, '-').replace('T', ' '))
    },


    //自定义上传方法..
    mainImgUpload(file) {
      var self = this;
      //判断扩展名
      const tmpcnt = file.file.name.lastIndexOf(".");
      const exname = file.file.name.substring(tmpcnt + 1);
      // const names = ["jpg", "jpeg", "webp", "png", "bmp"];
      // if (names.indexOf(exname) < 0) {
      //   this.$message.error("不支持的格式!");
      //   return;
      // }
      const fileName = file.file.uid + "." + exname;
      client
        .put(fileName, file.file)
        .then((res) => {
          if (res.url) {
            self.getUrl(res.url);
          } else {
            this.$message.error("文件上传失败");
          }
        })
        .catch((err) => {});
    },
    getUrl(url) {
      this.uploadVisible = false;
      // 获取富文本组件实例
      let quill = this.$refs.QuillEditor.quill;
      // 如果上传成功
      if (url) {
        // 插入图片，res为服务器返回的图片链接地址

        quill.insertEmbed(this.cursorIndex, "image", url);
        // 调整光标到最后
        quill.setSelection(this.cursorIndex + 1);
      } else {
        // 提示上传失败信息
      }
    },



    // 获取数据方法
    getdata(page) {
      this.loading = true;
      var parameter = {
        mobile: this.keyword,
        page: (page - 1) * this.pageparm.pageSize,
        pageSize: this.pageparm.pageSize,
        isVip2:this.isVip,
        expiryFilter: this.validityFilter || (this.isVip == "2" ? this.expiryFilter : "")
      };
      console.log("parameter",parameter)
      getUserList2(parameter).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.listData = res.data.list;
          this.pageparm.currentPage = page;
          this.pageparm.total = res.data.count;
          this.expirySummary = this.isVip == "2" ? (res.data.expirySummary || { thisMonthCount: 0 }) : { thisMonthCount: 0 }
          this.$nextTick(this.bindTableScrollbar)
          return;
        }
        this.$message({
          type: "info",
          message: res.msg,
        });
      });
    },


    // 分页插件事件
    callFather(parm) {
      console.log(parm)
      this.pageparm.pageSize = parm.pageSize
      this.getdata(parm.currentPage)
    },
    // 搜索事件
    search() {
      this.getdata(1)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      this.editForm = row
      this.from.userId = row.id;
    },

    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.expiry-toolbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin: 8px 0;
}
.expiry-toolbar-title { color: #606266; margin-right: 4px; }
.expiry-toolbar-title i { color: #e6a23c; margin-right: 4px; }
.table-scrollbar-top { overflow-x: auto; overflow-y: hidden; height: 14px; margin-bottom: 2px; }
.table-scrollbar-top-content { height: 1px; }
.selected-users-table /deep/ .el-table__body-wrapper { max-height: 260px; overflow-y: auto; }
.batch-expire-dialog .el-dialog__body { padding-top: 10px; }
.userRole {
  width: 100%;
}
.action-buttons {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 4px;
}
.period-cell {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
}
</style>

 
 

 



// WEBPACK FOOTER //
// src/views/user/User2.vue